import gql from 'graphql-tag'

export const updateUserProfile = (
	user_id,
	{ name, lastname, email, mobile, address_state_id, address, address_zipcode }
) => ({
	mutation: gql`
		mutation (
			$user_id: bigint!
			$name: String!
			$lastname: String!
			$email: String!
			$mobile: String!
			$address_state_id: bigint!
			$address: String!
			$address_zipcode: String!
		) {
			update_users_by_pk(
				pk_columns: { id: $user_id }
				_set: {
					name: $name
					lastname: $lastname
					email: $email
					mobile: $mobile
					address_state_id: $address_state_id
					address: $address
					address_zipcode: $address_zipcode
				}
			) {
				id
			}
		}
	`,
	variables: {
		user_id,
		name,
		lastname,
		email,
		mobile,
		address_state_id,
		address,
		address_zipcode
	}
})
